export enum Status {
  Initial = 'initial',
  Fulfilled = 'fulfilled',
  Rejected = 'rejected',
  Pending = 'pending',
}
